import e from"./RatingMenu.vue_vue&type=script&lang.js";import{render as t}from"./RatingMenu.vue_vue&type=template&id=0fb40347&lang.js";e.render=t;export default e;
//# sourceMappingURL=RatingMenu.vue.js.map
